import { action, computed, observable, reaction } from 'mobx'
import {
  getCansByCurrentUser,
  getNeedRemindFetchHandler,
  getServiceAccountCansInfo,
} from '../utils/fetchData'
import UserInfoStore from '../store/UserInfoStore'
import OverViewViewStore from '../store/OverViewViewStore'
import GlobalControlStore from './GlobalControlStore'

class Store {
  @observable cansStatusMap = new Map()
  @observable cansReminder = new Map()

  @observable cansNeedUpdate = false

  @observable _redTrash = null

  @computed get redTrash() {
    let count = 0
    for (let item of this.cansStatusMap.values()) {
      let trashPercentage = item.percentage
      if (trashPercentage >= 1) {
        count++
      }
    }
    return count
  }

  @observable _yellowTrash = null

  @computed get yellowTrash() {
    let count = 0
    for (let item of this.cansStatusMap.values()) {
      let trashPercentage = item.percentage
      if (trashPercentage < 1 && trashPercentage >= 0.75) {
        count++
      }
    }
    return count
  }

  @observable _greenTrash = null

  @computed get greenTrash() {
    let count = 0
    for (let item of this.cansStatusMap.values()) {
      let trashPercentage = item.percentage
      if (trashPercentage < 0.75) {
        count++
      }
    }
    return count
  }

  @observable _needTrash = null

  @computed get needTrash() {
    let count = 0
    for (let item of this.cansStatusMap.values()) {
      let trashPercentage = item.percentage
      if (trashPercentage >= 0.75) {
        count++
      }
    }
    return count
  }
}
const endsWithJFBJSuffix /* 经发保洁 */ = (str: String) => {
  return str.toUpperCase().endsWith('A') || str.toUpperCase().endsWith('B')
}

const CansStore = new Store()

reaction(
  //updateCansStatusMap
  () => UserInfoStore.initFlag,
  (flag, reaction) => {
    if (flag) {
      CansStore.cansStatusMap.clear()
      getCansByCurrentUser(
        action((data) => {
          if (data) {
            console.log(data)
            for (let can of data) {
              can.select = false //记录当前桶是否选中
              CansStore.cansStatusMap.set(can.canId, can)
            }
            if (UserInfoStore.groupId === '5d1da307d02eac3cec6d9481') {
              //对经发的处理
              let deleteArr = []
              for (let i = 0; i < data.length; i++) {
                let name1 = data[i].name.slice(0, data[i].name.length - 1)
                for (let j = i + 1; j < data.length; j++) {
                  let name2 = data[j].name.slice(0, data[j].name.length - 1)
                  if (name1 === name2) {
                    if (data[i].percentage > data[j].percentage) {
                      deleteArr.push(data[j].canId)
                    } else {
                      deleteArr.push(data[i].canId)
                    }
                  }
                }
              }
              for (let x = 0; x < deleteArr.length; x++) {
                CansStore.cansStatusMap.delete(deleteArr[x])
              }
              //去掉末尾A或B
              for (let can of CansStore.cansStatusMap.values()) {
                if (endsWithJFBJSuffix(can.name)) {
                  can.name = can.name.slice(0, can.name.length - 1)
                }
              }
            }
            CansStore.cansNeedUpdate = true
            GlobalControlStore.showLoading = false
          }
        })
      )
      OverViewViewStore.NoticeCanNeedUpdate = true
    }
    UserInfoStore.initFlag = false
  }
)
reaction(
  //noticeCansUpdateReaction
  () => OverViewViewStore.NoticeCanNeedUpdate,
  (flag, reaction) => {
    if (flag) {
      CansStore.cansReminder.clear()
      getNeedRemindFetchHandler(
        (data) => {
          if (data.length === 0 || !GlobalControlStore.TopTips) {
            OverViewViewStore.showNotice = false
            return
          } else {
            OverViewViewStore.showNotice = true
            OverViewViewStore.showTips = true
            if (OverViewViewStore.audioItem && GlobalControlStore.MusicTips) {
              OverViewViewStore.audioItem.play()
            }
          }
          for (let can of data) {
            CansStore.cansReminder.set(can.id, can)
          }
        },
        (err) => {}
      )
    }
    OverViewViewStore.NoticeCanNeedUpdate = false
  }
)

export default CansStore



// WEBPACK FOOTER //
// ./src/store/CansStore.js